<div class="flex-column gap-32">
	<app-card preCardTitle="Route Management">
		<div *appCardContent class="settings-header-container">
			<div class="settings-header-title">
				Create a new route configuration
			</div>
			<div class="settings-header-actions">
				<button
						(click)="addRouteConfiguration()"
						mat-stroked-button
						color="accent"
				>
					Add Routes
				</button>
			</div>
		</div>
	</app-card>

	@if (isLoading) {
		<mat-spinner diameter="30" class="mx-a my-10"></mat-spinner>
	} @else {
		<app-card preCardTitle="Route Configurations">
			<div *appCardContentRaw>
				<mat-menu #menuRoute="matMenu">
					<ng-template matMenuContent let-routeConfiguration="routeConfiguration">
						<button mat-menu-item
								[routerLink]="['/', RootRoute.SETTINGS, SettingsRoute.MANAGE_ROUTES, routeConfiguration.base.id]">
              <mat-icon>folder_open</mat-icon>
							Open
						</button>
            <button mat-menu-item (click)="copyConfiguration(routeConfiguration.base.id, routeConfiguration.base.name)">
              <mat-icon>content_copy</mat-icon>
              Clone
            </button>
            <button mat-menu-item
                    [routerLink]="['/', RootRoute.SETTINGS, SettingsRoute.MANAGE_ROUTES, 'configuration', routeConfiguration.base.id, 'change-log']">
              <mat-icon>history</mat-icon>
              Version History
            </button>
            <button mat-menu-item (click)="removeConfiguration(routeConfiguration.base.id, routeConfiguration.base.name)">
              <mat-icon>delete</mat-icon>
              Remove
            </button>
          </ng-template>
				</mat-menu>
				@if (root.hasChildren()) {
					<mat-nav-list class="raw-card-list">
						@for (routeConfiguration of root.children; track routeConfiguration.base.id) {
							<mat-list-item
									[routerLink]="['/', RootRoute.SETTINGS, SettingsRoute.MANAGE_ROUTES, routeConfiguration.base.id]">
								<a matListItemTitle>{{ routeConfiguration.base.name }}</a>
								<div matListItemMeta>
									<button mat-icon-button
											(click)="$event.stopPropagation()"
											[matMenuTriggerFor]="menuRoute"
											[matMenuTriggerData]="{routeConfiguration:routeConfiguration}"
											aria-label="Menu">
										<mat-icon>more_vert</mat-icon>
									</button>
								</div>
							</mat-list-item>
							@if (!$last) {
								<mat-divider></mat-divider>
							}
						}
					</mat-nav-list>
				} @else {
					<div class="p-15 no-data">No route configurations defined yet</div>
				}
			</div>
		</app-card>
	}
</div>
